import React, { useEffect, useRef, useState } from "react";
import classes from "./RevenueSheet.module.scss";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Badge, Button, MenuItem } from "@mui/material";
import DataTableComponent from "../../../components/DataTableComponent/DataTableComponent";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

import InsertLinkIcon from "@mui/icons-material/InsertLink";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import searchIcon from "../../../assets/Images/searchImage.svg";
import {
  DownloadRevenueDetailsAPICall,
  getRevenueByClientAPICall,
  getRevenuedayWiseAPICall,
  getdashBoardIntroducerCommissiondayWiseGraphDataAPICall,
} from "../../../Utils/APICalls";
import { Helmet } from "react-helmet";
import DownloadIcon from "@mui/icons-material/Download";

import SnackBar from "../../../Components copy/SnackBars/SnackBar";
import SucessSnackBar from "../../../components/SnackBar/SuccessSnackBar";

const titletextStyle = {
  fontSize: "13px",
  fontWeight: 600,
  color: "rgba(34, 34, 34, 1)",
  cursor: "pointer",
};
const divStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const contenttextStyle = { fontSize: "12px", fontWeight: 600 };

const RevenueData = [
  {
    client_code: "KC1593",
    client_name: "Leon Kennedy",
    email: "leonkennedy@gmail.com",
    clientReferral: "AMMU",
    netPay: "₹4582",
    revenue: "₹458223",
  },
  {
    client_code: "KC1593",
    client_name: "Leon Kennedy",
    email: "leonkennedy@gmail.com",
    clientReferral: "AMMU",
    netPay: "₹4582",
    revenue: "₹4582",
  },
  {
    client_code: "KC1593",
    client_name: "Leon Kennedy",
    email: "leonkennedy@gmail.com",
    clientReferral: "AMMU",
    netPay: "₹4582",
    revenue: "₹4582",
  },
  {
    client_code: "KC1593",
    client_name: "Leon Kennedy",
    email: "leonkennedy@gmail.com",
    clientReferral: "AMMU",
    netPay: "₹4582",
    revenue: "₹4582",
  },
  {
    client_code: "KC1593",
    client_name: "Leon Kennedy",
    email: "leonkennedy@gmail.com",
    clientReferral: "AMMU",
    netPay: "₹4582",
    revenue: "₹4582",
  },
];

const Day: any = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];

const monthmapping: any = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

export default function RevenueSheet() {
  const pageRef: any = useRef();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [displayYearandMonth, setDisplayYearandMonth] = useState("");
  const [presentDate, setPresentDate] = useState(new Date().getDate());

  const [currentIndex, setCurrentIndex] = useState<number | null>();
  const [currentTimeLineIndex, setCurrentTimeLineIndex] = useState<
    number | null
  >();
  const [data, setData] = useState(RevenueData);
  const [loading, setloading] = useState(false);
  const [perDayRevenue, setPerDayRevenue] = useState<any | string>(null);
  const [search, setsearch] = useState("");
  const userDetails: any = sessionStorage.getItem("userDetails");
  const UserDetails: any = JSON.parse(userDetails);
  const [presentMonthAndYear, setPresentmonthAndYear] = useState("");
  const [timelineData, setTimelineData] = useState([]);
  const [currentRevenueTotal, setCurrentRevenueTotal] = useState(0);
  const [displayBadge, setdisplayBadge] = useState(false);
  const [timeLineMonth, setTimeLineMonth] = useState("");
  const [timeLineYear, setTimeLineYear] = useState<any>();
  const [paginationCount, setpaginationCount] = useState(1);
  const [revenuedata, setRevenueData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [increasefontSize, setIncreaseFontSize] = useState(false);
  const [scrolljump, setscrolljump] = useState(true);
  const [downloadMessage, setDownloadMessage] = useState("");
  const [downloadErrorMessage, setDownloadErrorMessage] = useState("");

  useEffect(() => {
    const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
      new Date()
    );
    const year = currentDate.getFullYear();
    const formattedDate = `${month} ${year}`;
    setPresentmonthAndYear(formattedDate);
  }, []);

  // useEffect(() => {
  //   pageRef.current.scrollTo(0, 0, { behaviour: "smooth" });
  // }, [revenuedata]);

  useEffect(() => {
    if (displayYearandMonth !== "") {
      window.scrollTo({ top: 0 });
      getDashBoardRevenueGraphData();
      GetRevenueByClient();
    }

    if (displayYearandMonth === presentMonthAndYear) {
      setPresentDate(new Date().getDate());
    } else {
      setPresentDate(31);
    }
  }, [displayYearandMonth, pageNo]);

  useEffect(() => {
    console.log("increasefontSize", increasefontSize);
    if (increasefontSize) {
      GetRevenueByClient();
    }

    if (!increasefontSize && displayYearandMonth !== "") {
      GetRevenueDayWise();
    }
  }, [increasefontSize]);

  const GetRevenueByClient = () => {
    setloading(true);
    let obj: any = {
      month: displayYearandMonth,
      page_no: pageNo,
      page_size: 20,
    };
    setscrolljump(false);
    getRevenueByClientAPICall(obj)
      .then((response: any) => {
        setloading(false);
        setscrolljump(true);
        setRevenueData(
          response.data.data.revenue_data ? response.data.data.revenue_data : []
        );
        setTotalRows(Math.ceil(response.data.data.total_records / 20));
      })
      .catch((error: any) => {
        setscrolljump(true);
        setloading(false);
      });
  };
  const GetRevenueDayWise = () => {
    setloading(true);
    let obj: any = {
      month: displayYearandMonth,
      day: currentTimeLineIndex ? currentTimeLineIndex + 1 : 1,
      page_no: pageNo,
      page_size: 20,
    };
    setscrolljump(false);
    if (displayYearandMonth !== "") {
      getRevenuedayWiseAPICall(obj)
        .then((response: any) => {
          setloading(false);
          setscrolljump(true);
          setRevenueData(
            response.data.data.revenue_data
              ? response.data.data.revenue_data
              : []
          );
          setTotalRows(Math.ceil(response.data.data.total_records / 20));
        })
        .catch((error: any) => {
          setloading(false);
          setscrolljump(true);
        });
    }
  };

  const getDashBoardRevenueGraphData = () => {
    let obj: any = {
      month: displayYearandMonth,
    };
    setdisplayBadge(true);
    setCurrentIndex(null);
    getdashBoardIntroducerCommissiondayWiseGraphDataAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);
        setdisplayBadge(false);
        if (response.data.data) {
          const newData = response.data.data.map((item: any, index: any) => ({
            ...item,
            date: Day[index], // Adjusted to start from 0 index
          }));
          const latest = response.data.data.every(
            (a: any) => a.Introducer_Commission === 0
          );

          const poppedData = newData.pop();

          setTimelineData(!latest ? newData : []);

          const totalAmount = response.data.data.reduce(
            (sum: any, item: any) => sum + item.Introducer_Commission,
            0
          );
          setCurrentRevenueTotal(totalAmount);
        } else {
          setCurrentRevenueTotal(0);
          setTimelineData(Day);
        }

        // setDashboarddata(response.data.data[0]);
      })
      .catch((error: any) => {
        setdisplayBadge(false);
        // console.log("error", error);
      });
  };

  useEffect(() => {
    const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
      currentDate
    );
    const year = currentDate.getFullYear();

    const formattedDate = `${month} ${year}`;
    setTimeLineYear(year);
    setTimeLineMonth(month);
    setDisplayYearandMonth(formattedDate);
  }, [currentDate]);

  const handlePreviousMonthClick = () => {
    setPageNo(1);
    setpaginationCount(1);
    const previousMonth = new Date(currentDate);
    previousMonth.setMonth(previousMonth.getMonth() - 1);
    // setPresentDate(31)
    setCurrentDate(previousMonth);
  };

  const handleNextMonthClick = () => {
    setPageNo(1);
    setpaginationCount(1);
    const previousMonth = new Date(currentDate);
    previousMonth.setMonth(previousMonth.getMonth() + 1);
    setCurrentDate(previousMonth);
  };
  const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    currentDate
  );
  const newmonth = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    new Date()
  );
  const presentYear = currentDate.getFullYear();
  const yearNow = new Date().getFullYear();

  const getOrdinalSuffix = (date: any) => {
    if (date >= 11 && date <= 13) {
      return "th";
    }
    switch (date % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const columns = [
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <InsertDriveFileOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Client Code</p>
          </div>
        </b>
      ),
      selector: "TradeCode",
      // sortable: true,

      cell: (row: any) => <b style={contenttextStyle}>{row.TradeCode}</b>,
    },
    // {
    //   name: (
    //     <b style={titletextStyle}>
    //       {" "}
    //       <div style={divStyles}>
    //         <AccountBalanceWalletIcon
    //           style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
    //         />{" "}
    //         <p>No.Of Orders</p>
    //       </div>
    //     </b>
    //   ),
    //   selector: "No_Of_Orders",

    //   cell: (row: any) => <b style={contenttextStyle}>{row.No_Of_Orders}</b>,
    // },
    // {
    //   name: (
    //     <b style={titletextStyle}>
    //       <div style={divStyles}>
    //         <PersonOutlineOutlinedIcon
    //           style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
    //         />{" "}
    //         <p>Name</p>
    //       </div>
    //     </b>
    //   ),
    //   selector: "client_name",
    //   // sortable: true,

    //   cell: (row: any) => (
    //     <div className={classes.nameWrapper}>
    //       <div className={classes.titleSection}>
    //         <p style={{ fontSize: "12px", fontWeight: 600 }}>
    //           {row.client_name}
    //         </p>
    //         <p style={{ fontSize: "10px", color: "rgba(174, 174, 174, 1)" }}>
    //           {row.email}
    //         </p>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <PaymentsOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Revenue</p>
          </div>
        </b>
      ),
      selector: "Revenue",

      cell: (row: any) => <b style={contenttextStyle}>{row.Revenue}</b>,
    },

    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <InsertLinkIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Client Referral Amount</p>
          </div>
        </b>
      ),
      selector: "ClientReferralAmount",
      // sortable: true,
      // width: "200px",
      cell: (row: any) => (
        <b style={contenttextStyle}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // width: "130px",
            }}
          >
            <p>{row.ClientReferralAmount}</p>
          </div>
        </b>
      ),
    },

    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <AccountBalanceWalletIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Net Pay</p>
          </div>
        </b>
      ),
      selector: "NetPay",

      cell: (row: any) => <b style={contenttextStyle}>{row.NetPay}</b>,
    },
  ];

  const handleSearchChange = (e: any) => {
    setsearch(e.target.value);
  };

  const handleDisplayDayRevenue = (daydata: any) => {
    setCurrentIndex(daydata - 1);
    const dayRevenue: any = timelineData.filter(
      (a: any, index: any) => index === daydata - 1
    );
    // console.log("dayRevenue", dayRevenue[0].Introducer_Commission);
    setPerDayRevenue(dayRevenue[0].Introducer_Commission);
  };

  const handleTimeLineClick = (a: any) => {
    setCurrentTimeLineIndex(a - 1);
    console.log("a-1", a - 1);

    if (a - 1 === currentIndex) {
      setIncreaseFontSize(!increasefontSize);
    }

    console.log("a", a);
  };

  const getWeekendDates = (year: any, month: any) => {
    // console.log("yearmonth", year, month);
    const weekendDays: any = { Saturdays: [], Sundays: [] };
    const firstDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);

    for (let day = firstDay; day <= lastDay; day.setDate(day.getDate() + 1)) {
      if (day.getDay() === 0) {
        weekendDays.Sundays.push(day.getDate());
      } else if (day.getDay() === 6) {
        weekendDays.Saturdays.push(day.getDate());
      }
    }

    return weekendDays;
  };

  const { Saturdays, Sundays } = getWeekendDates(
    timeLineYear,
    monthmapping[timeLineMonth]
  );

  const handlePageChange = (value: any, pagenumber: any) => {
    setpaginationCount(pagenumber);
    setPageNo(pagenumber);
  };

  const handleDownloadRevenue = () => {
    let obj: any = {
      month: displayYearandMonth,
    };

    DownloadRevenueDetailsAPICall(obj)
      .then((response: any) => {
        
        downloadCsv(response.data);
        setDownloadMessage("Reports Download successfully");
        setTimeout(() => {
          setDownloadMessage("");
        }, 5000);
      })
      .catch((error: any) => {
        if(error.response.data.error.message){
          setDownloadErrorMessage(error.response.data.error.message);
        } else{
          setDownloadErrorMessage("Error downloading");
        }
       
        setTimeout(() => {
          setDownloadErrorMessage("");
        }, 5000);
      });
  };

  const downloadCsv = (csvContent) => {
    const blob = new Blob([csvContent], { type: "csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Revenue ${displayYearandMonth}.csv`);
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const numbersArray = Array.from(
    { length: timelineData.length },
    (_, index) => index + 1
  );

  // console.log("numbersArray",numbersArray)

  return (
    <div>
      <Helmet>
        <title>Revenue Sheet</title>
        <meta name="Revenue" content="Revenue" />
      </Helmet>
      <SnackBar message={downloadErrorMessage} />
      <SucessSnackBar message={downloadMessage} />
      <div className={classes.mainWrapper}>
        <div className={classes.leftContainerTopTitle}>
          {/* <p className={classes.welcomeText}>
          Welcome {UserDetails ? UserDetails.Name : ""}
        </p> */}
          <p className={classes.dashboardText}>Revenue Sheet</p>
          <div
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "space-between",
            }}
          >
            <div className={classes.nextTopPreviousSection}>
              <div
                className={classes.topprevious}
                onClick={handlePreviousMonthClick}
              >
                <KeyboardArrowLeftIcon />
              </div>
              <div className={classes.topyearText}>{displayYearandMonth}</div>
              <div
                className={classes.topnext}
                onClick={() => {
                  if (month !== newmonth || presentYear !== yearNow) {
                    handleNextMonthClick();
                  }
                }}
                style={{
                  background:
                    month === newmonth && presentYear === yearNow ? "grey" : "",
                }}
              >
                <KeyboardArrowRightIcon />
              </div>
            </div>
            <div>
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  fontSize: "13px",
                  "&:hover": {
                    background: "rgba(0, 103, 121, 1)",
                  },
                }}
                startIcon={<DownloadIcon />}
                onClick={handleDownloadRevenue}
              >
                Download reports
              </Button>
            </div>
          </div>
        </div>

        <div className={classes.currentRevenueContainer}>
          <div className={classes.revenueDiv}>
            <div className={classes.revenueDivText}>
              <p className={classes.currentText}>Current Revenue</p>
              <p className={classes.revenueasOn}>
                as on {presentDate}
                {getOrdinalSuffix(presentDate)} {month}
              </p>
            </div>
            <p className={classes.revenueAmount}>
              ₹{Math.floor(parseFloat(currentRevenueTotal.toString()))}
            </p>
          </div>
          <p className={classes.timelineText}>Timeline</p>
          {scrolljump && (
            <div className={classes.scallerSection}>
              {numbersArray.map((a: any, index: any) => (
                <>
                  <Badge
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    badgeContent={
                      index === currentIndex ? (
                        <span
                          style={{
                            marginTop: "30px",

                            marginLeft: "-20px",
                            padding: "5px 10px",
                            background: "rgba(35, 105, 255, 1)",
                            fontSize: "14px",
                            color: "white",
                            borderRadius: "5px",
                          }}
                        >
                          <div className={classes.triangle}></div>
                          {perDayRevenue === 0 ? (
                            <span style={{ padding: "0 10px" }}>₹0</span>
                          ) : (
                            `₹${Math.floor(
                              parseFloat(perDayRevenue.toString())
                            )}`
                          )}
                        </span>
                      ) : null
                    }
                    // color="info"

                    max={9999999}
                  >
                    <div
                      className={classes.scallerSectionText}
                      style={{
                        color:
                          index < presentDate
                            ? Saturdays.includes(a) || Sundays.includes(a)
                              ? "red"
                              : "black"
                            : "grey",

                        fontWeight:
                          index === currentTimeLineIndex && !increasefontSize
                            ? 900
                            : "",
                        background:
                          index === currentTimeLineIndex && !increasefontSize
                            ? "white"
                            : "",
                        borderRadius: "10px",
                      }}
                      onMouseEnter={() => {
                        if (index < presentDate && currentRevenueTotal !== 0) {
                          if (Saturdays.includes(a) || Sundays.includes(a)) {
                          } else {
                            handleDisplayDayRevenue(a);
                          }

                          // setCurrentIndex(a - 1);
                          // setPerDayRevenue("₹4582");
                        }
                      }}
                      onClick={() => {
                        if (index < presentDate && currentRevenueTotal !== 0) {
                          if (Saturdays.includes(a) || Sundays.includes(a)) {
                          } else {
                            handleTimeLineClick(a);
                          }
                        }
                      }}
                    >
                      {a}
                    </div>
                  </Badge>
                  <div
                    className={classes.scallerSectionDivider}
                    style={{ width: index === 30 ? "0px" : "" }}
                  ></div>
                </>
              ))}
            </div>
          )}
        </div>

        <div
          className={classes.tableWrapper}
          style={{ border: loading ? " " : "1px solid rgba(213, 233, 236, 1)" }}
        >
          <DataTableComponent
            data={revenuedata}
            columns={columns}
            loading={loading}
            paginationCount={paginationCount}
            handlePageChange={handlePageChange}
            totalRows={totalRows}
          />
        </div>
      </div>
    </div>
  );
}
